export const ApplicationType = Object.freeze({
  WEB: "2",
});

export const CustomerProfileType = Object.freeze({
  UNREGISTERED_CUSTOMER: "1",
});
